module.exports = __webpack_public_path__ + "icon-users.svg?92eefb8d03fb87002acf4f0cc3fab18d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-users.svg
// module id = 565
// module chunks = 0